import React from 'react'
import { ChipList, Chip } from '@progress/kendo-react-buttons'
import { TextAreaHLPure, InputHLPure, PanelBarGLPure, Traslates, CheckBoxHLPure, DataPickerHLPure, DropDownBtnHLPure } from '../../pures'

const FollowUpDocumentBasicData = (props) => {
    let {
        t,
        documentData,
        name,
        alias,
        obligatory,
        confidential,
        valueDocument,
        description,
        tags,
        handleChangeName,
        handleChangeAlias,
        handleChangeDescription,
        onChangeDatepicker,
        handleChangeValueDoc,
        handleChangeCheckConfidential,
        handleChangeCheckObligatory,
        handleDeleteChipTag,
        dateStart,
        dateEnd,
        errorInputDateStart,
        errorInputTextDateStart,
        errorInputDateEnd,
        errorInputTextDateEnd,
        onChangeDatepickerDateEnd,
        handleChangeCheckPenalty,
        penalty,
        errorInputValueDoc,
        errorInputTextValueDoc,
        onBlurValueDoc,
        formatCeleb,
        formatVen,
        disableElements,
        inputTag,
        handleInputTag,
        onBlurInputTag,
        limitDateDue,
        monetaryUnit,
        handleMonetaryUnit
    } = props


    return (
        <div className='digitalVaultFollowUpDocument-followUpDocumentBasicData-panel'>
            <PanelBarGLPure
                expandedPanel={true}
                titlePanel={t('digitalVaultFollowUpDocument.basic.data')}
                id='followUpDocument-basic-data'
            >
                <div className='digitalVaultFollowUpDocument-followUpDocumentBasicData'>
                    {
                        props.canEditName && <div className='digitalVaultFollowUpDocument-followUpDocumentBasicData-alias'>
                            <InputHLPure
                                typeInput='text'
                                labelInput={documentData.infoType === 'Documento' ? t('digitalVaultFollowUpDocument.name.document') : t('digitalVaultFollowUpDocument.name.file')}
                                valueInput={name}
                                handleChangeInput={handleChangeName}
                                tooltipShow={false}
                                informationIcon={false}
                                inputActive={true}
                                disabled={disableElements}
                                required={true}
                            />
                        </div>
                    }
                    <div className='digitalVaultFollowUpDocument-followUpDocumentBasicData-alias'>
                        <InputHLPure
                            typeInput='text'
                            labelInput={documentData.infoType === 'Documento' ? t('digitalVaultFollowUpDocument.alias') : t('digitalVaultFollowUpDocument.fileAlias')}
                            valueInput={alias}
                            handleChangeInput={handleChangeAlias}
                            tooltipShow={false}
                            informationIcon={false}
                            inputActive={true}
                            disabled={disableElements}
                        />
                    </div>
                    <div className='digitalVaultFollowUpDocument-followUpDocumentBasicData-description'>
                        <TextAreaHLPure
                            labelTextArea={t('digitalVaultFollowUpDocument.description')}
                            valueTextData={description}
                            handleChangeTextArea={handleChangeDescription}
                            disabled={disableElements}
                        />
                    </div>
                    <div className='digitalVaultFollowUpDocument-followUpDocumentBasicData-dates-checkbox'>
                        <div className='digitalVaultFollowUpDocument-followUpDocumentBasicData-dates'>
                            <div className='digitalVaultFollowUpDocument-followUpDocumentBasicData-start-date'>
                                <Traslates>
                                    <DataPickerHLPure
                                        labelDataPicker={t('digitalVaultFollowUpDocument.date.celeb')}
                                        valueDate={dateStart}
                                        handleChangeDate={(e) => onChangeDatepicker(e)}
                                        formatPicker={formatCeleb}
                                        disabled={disableElements}
                                    />
                                </Traslates>
                                {
                                    errorInputDateStart && (
                                        <span className='hint-message-error'>{errorInputTextDateStart}</span>
                                    )
                                }
                            </div>
                            <div className='digitalVaultFollowUpDocument-followUpDocumentBasicData-end-date'>
                                <Traslates>
                                    <DataPickerHLPure
                                        labelDataPicker={t('digitalVaultFollowUpDocument.date.due')}
                                        valueDate={dateEnd}
                                        handleChangeDate={(e) => onChangeDatepickerDateEnd(e)}
                                        formatPicker={formatVen}
                                        disabled={disableElements}
                                        limitDate={limitDateDue}
                                    />
                                </Traslates>
                                {
                                    errorInputDateEnd && (
                                        <span className='hint-message-error'>{errorInputTextDateEnd}</span>
                                    )
                                }
                            </div>
                            <div className='digitalVaultFollowUpDocument-followUpDocumentBasicData-checkbox-container'>
                                <div className='digitalVaultFollowUpDocument-followUpDocumentBasicData-checkbox'>
                                    <CheckBoxHLPure
                                        checkedState={confidential}
                                        onChangeHandler={(e) => handleChangeCheckConfidential(e)}
                                        disabled={disableElements}
                                    />
                                    <h1 >{t('documentPanelBarBasicData.confidential')}</h1>
                                </div>
                                <div className='digitalVaultFollowUpDocument-followUpDocumentBasicData-checkbox-obligatory'>
                                    <CheckBoxHLPure
                                        checkedState={obligatory}
                                        onChangeHandler={(e) => handleChangeCheckObligatory(e)}
                                        disabled={disableElements}
                                    />
                                    <h1 >{t('documentPanelBarBasicData.obligatory')}</h1>
                                </div>
                                <div className='digitalVaultFollowUpDocument-followUpDocumentBasicData-checkbox-penalty'>
                                    <CheckBoxHLPure
                                        checkedState={penalty}
                                        onChangeHandler={(e) => handleChangeCheckPenalty(e)}
                                        disabled={disableElements}
                                    />
                                    <h1 >{t('documentPanelBarBasicData.penalty')}</h1>
                                </div>
                            </div>
                        </div>
                        <div className='digitalVaultFollowUpDocument-followUpDocumentBasicData-transaction-value'>
                            <div className='digitalVaultFollowUpDocument-followUpDocumentBasicData-value'>
                                <InputHLPure
                                    typeInput='text'
                                    labelInput={t('documentPanelBarBasicData.transaction.value')}
                                    valueInput={valueDocument}
                                    handleChangeInput={handleChangeValueDoc}
                                    tooltipShow={false}
                                    informationIcon={false}
                                    inputActive={true}
                                    errorInputText={errorInputTextValueDoc}
                                    errorInput={errorInputValueDoc}
                                    onBlur={onBlurValueDoc}
                                    disabled={disableElements}
                                />
                            </div>
                            {props.monetaryUnits.length > 0 &&
                                <div className='digitalVaultFollowUpDocument-followUpDocumentBasicData-value'>
                                    <DropDownBtnHLPure
                                        onDropDownChange={e => handleMonetaryUnit(e)}
                                        labelDropDown={t('digitalVault.editDocument.combobox.currencyType')}
                                        optionsDropDown={props.monetaryUnits}
                                        optionsValue={monetaryUnit}
                                        valueItem={'pluralName'}
                                        nameOption={'pluralName'}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                    <div className='digitalVaultFollowUpDocument-followUpDocumentBasicData-container-tags'>
                        <InputHLPure
                            typeInput='text'
                            labelInput={t('digitalVaultFollowUpDocument.tags')}
                            valueInput={inputTag}
                            handleChangeInput={(e) => handleInputTag(e)}
                            tooltipShow={false}
                            informationIcon={false}
                            inputActive={true}
                            onBlur={onBlurInputTag}
                            disabled={disableElements}
                        />
                        <div className='digitalVaultFollowUpDocument-followUpDocumentBasicData-tags'>
                            <ChipList
                                selection='single'
                                data={tags}
                                chip={(props) => <Chip removable={true} {...props} onRemove={(e) => handleDeleteChipTag(e)} />}
                            />
                        </div>
                    </div>
                </div>
            </PanelBarGLPure>
        </div>
    )
}

export { FollowUpDocumentBasicData as default }